/* The link after the muted sentence — „Wyciszone: …. Zmień, co liczy się jako zadanie" — on every
 * surface that names the muted kinds (attention-queue R18): the Pulpit's task card, `/zadania`'s
 * foot and the client's Przegląd. Ink and an underline, so it reads as a link on a line of
 * `--text-2` without taking the accent, which belongs to real actions. Moved here from the Pulpit's
 * and `/zadania`'s own stylesheets on 24 September 2026, when the Przegląd became its third reader.
 *
 * A class-only stylesheet, for the reason `inlineTextButton.module.css` gives: the sentence it
 * stands in belongs to the surface. */
.mutedLink {
  font-weight: var(--fw-bold);
  color: var(--text);
  text-decoration: underline;
  text-underline-offset: var(--space-3px);
  border-radius: var(--radius-5px);
}

.mutedLink:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}
